import Request from 'utils/request';
import config from 'config/Config';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams } from 'utils/constants';

export default class {
  /**
   * 获取订单列表
   */
  static getOrderList(data) {
    return Request({
      url: `tradecore/after-sale/apply/order-select/list-by-page`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data
    });
  }

  // 退货交验，
  static checkOrderReturn(tradeNoList) {
    return Request({
      url: `tradecore/after-sale/apply/beforeSaveProcess`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: tradeNoList,
      ignoreErr: true
    });
  }

  /**
   * 获取产品列表
   */
  static getProductList(params) {
    return Request({
      url: `tradecore/after-sale/apply/item-select/list-by-page`,
      host: config.HOST_MALL,
      params
    });
  }

  // 获取地址列表
  static getAddress(params) {
    return Request({
      // url: `tradecore/member/address/queryByPage`,
      // host: config.HOST_MALL,
      // params,
      url: `biz/tradecore/trade/get-by-logistics`,
      host: config.HOST_MALL,
      params
      // url: `biz/tradecore/trade/get-by-logistics`,
      // host: config.HOST_MALL,
      // params
    });
  }

  /**
   * 申请售后提交
   */
  static applyAfterSale(data) {
    return Request({
      url: `tradecore/after-sale/multi/apply/save`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ApplyAfterSaleServ.js